import React from "react";

import { Link } from "react-router-dom";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const ProductCard = props => {
  return (
    <Card className="product_item" style={props.addStyles}>
      <CardActionArea>
        <CardMedia
          className="product_image"
          image={props.image}
          src={props.image}
          title=""
          style={{
            width: "100%",
            backgroundSize: "contain",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
            overflow: "hidden",
            height: "150px"
          }}
        />
        <CardContent style={{ padding: "5px" }}>
          <Typography
            gutterBottom
            component="div"
            style={{
              textTransform: "uppercase",
              height: "50px",
              background: "#00000017",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: 'center'
            }}
          >
            <p style={{ margin: 0 }}>{props.title}</p>
          </Typography>
        </CardContent>

        <CardContent style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          padding: "5px"
        }}>
          {props.isInStore === 'Да' 
            ? <Typography
                gutterBottom
                variant="subtitle1"
                component="h1"
                style={{
                  color: "#21cc76"
                }}
              >
                Есть в наличии
              </Typography>
            : <Typography
                gutterBottom
                variant="subtitle1"
                component="h1"
                style={{
                  color: "red"
                }}
              >
                Нет в наличии
              </Typography>
          }
          

          <Typography
            gutterBottom
            variant="subtitle1"
            component="h1"
            style={{
              color: "#000",
              fontWeight: '500'
            }}
          >
              {props.price} MDL
          </Typography>
        </CardContent>

        <CardContent
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            padding: "5px",
            borderTop: '1px solid #00000017',
            borderBottom: '1px solid #00000017',
            background: '#0000000a'
          }}
        >
          <Typography
            gutterBottom
            variant="subtitle1"
            component="p"
            style={{
              fontSize: "12px",
              margin: '0'
            }}
          >
            Произвадитель
          </Typography>
          <Typography
            gutterBottom
            variant="subtitle1"
            component="p"
            style={{
              fontSize: "12px",
              textTransform: "uppercase",
              margin: '0'
            }}
          >
            {props.brand}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions
        style={{
          justifyContent: "space-around"
        }}
      >
        <a
          href={`/products/${props.linkTo}`}
          style={{
            textDecoration: "none"
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="primary"
            className="show_button"
            style={{
              backgroundColor: "#005f9c"
            }}
          >
            Посмотреть
          </Button>
        </a>
        {props.user ? (
          <Link
            to={{
              pathname: `/products/${props.linkTo}/edit`,
              state: { product: props.product }
            }}
            style={{
              textDecoration: "none"
            }}
          >
            <Button
              variant="outlined"
              size="small"
              color="primary"
              className="show_button"
              style={{
                color: "#005f9c",
                borderColor: "#005f9c"
              }}
            >
              Изменить
            </Button>
          </Link>
        ) : null}
      </CardActions>
    </Card>
  );
};

export default ProductCard;
